
import{polyfill}from"./polyfill.js";

polyfill();